import React, { ReactElement } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { PropsDeChamp } from '../../Common/ChampFormulaire';
import { useField } from 'formik';
import { Fichier } from '../../../../../common/src/entities';
import { BiX } from 'react-icons/all';
import TooltipSimple from '../../Common/TooltipSimple';

type PropsChampFichier = {
    accept?: string;
    labelCol: number;
};

export default function ChampFichier<T>(props: PropsDeChamp<T> & PropsChampFichier): ReactElement {
    const { id, titre, accept, labelCol } = props;
    const [field, , helpers] = useField<Fichier | null>(String(id));
    return (
        <Form.Group>
            <Row>
                <Col xs={labelCol}>
                    <Form.Label>{titre}</Form.Label>
                </Col>
                <Col>
                    <Form.File custom>
                        <Form.File.Input
                            onChange={(event) => {
                                const file = event.target.files[0];
                                const reader = new FileReader();
                                reader.addEventListener('load', () => {
                                    helpers.setValue(({
                                        name: file.name,
                                        base64: reader.result,
                                    } as unknown) as Fichier);
                                });
                                if (file) reader.readAsDataURL(file);
                            }}
                            accept={accept}
                        />
                        <Form.File.Label data-browse="Parcourir">
                            {field.value?.name ?? 'Choisir un fichier'}
                        </Form.File.Label>
                        {field.value ? (
                            <div
                                style={{
                                    padding: '8px 105px 8px 0',
                                    zIndex: 10,
                                    position: 'absolute',
                                    right: 0,
                                    top: 0,
                                }}
                            >
                                <TooltipSimple texte="Supprimer">
                                    <Button
                                        variant="link"
                                        className="d-flex align-items-center text-muted p-0"
                                        onClick={() => helpers.setValue(null)}
                                    >
                                        <BiX size="1.25em" />
                                    </Button>
                                </TooltipSimple>
                            </div>
                        ) : null}
                    </Form.File>
                </Col>
            </Row>
        </Form.Group>
    );
}
